var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6895 0H1.26365C0.561623 0 0 0.5625 0 1.26563V28.7813C0 29.4375 0.561623 30 1.26365 30H28.7364C29.4384 30 30 29.4375 30 28.7344V1.26563C29.9532 0.5625 29.3916 0 28.6895 0ZM8.89236 25.5469H4.44618V11.25H8.89236V25.5469ZM6.64587 9.28125C5.24181 9.28125 4.07176 8.10938 4.07176 6.70313C4.07176 5.29688 5.24181 4.125 6.64587 4.125C8.04992 4.125 9.21997 5.29688 9.21997 6.70313C9.21997 8.15625 8.09672 9.28125 6.64587 9.28125ZM25.507 25.5469H21.0608V18.6094C21.0608 16.9688 21.014 14.8125 18.7676 14.8125C16.4743 14.8125 16.0998 16.6406 16.0998 18.4688V25.5469H11.6537V11.25H15.9126V13.2188H15.9594C16.5679 12.0938 18.0187 10.9219 20.1716 10.9219C24.6646 10.9219 25.507 13.875 25.507 17.7187V25.5469Z",
    fill: "#4EA27D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.591cac8d.svg";
export { ForwardRef as ReactComponent };